import { createSelector } from 'reselect';
import { getBasicDetailsForm } from './basicDetails';
import { getIncidentDetailsForm } from './incidentDetails';
import {
    BASIC_DETAILS_LABELS,
    INCIDENT_DETAIL_LABELS,
    WITNESS_DETAILS,
    OTHER_DETAIL_LABELS,
    AMC_REQUIRED_DOCUMENTS,
    ACCIDENT_LABELS,
    DETAILS_OF_PASSENGER,
    POLICE_DETAILS_LABELS,
    DRIVER_DETAILS,
    OTHER_THIRD_PARTY,
    DAMAGE_PROPERTY,
    PERSONAL_INJURIES,
} from '../../actions/allSureMotorClaim/types';
import { getUploadDocumentForm } from './uploadDocuments';
import { getOtherDetailsForm } from './otherDetails';

export const getBasicDetailsSummary = createSelector(getBasicDetailsForm, (basicDetailsForm) => {
    return Object.keys(BASIC_DETAILS_LABELS).flatMap((fieldKey) =>
        basicDetailsForm[fieldKey].value
            ? {
                  label: BASIC_DETAILS_LABELS[fieldKey],
                  value: basicDetailsForm[fieldKey].value ?? '-',
              }
            : []
    );
});

export const getDocumentsSummary = createSelector(getUploadDocumentForm, (documentsForm) => {
    return Object.keys(documentsForm).flatMap((fieldKey) => ({
        label: (AMC_REQUIRED_DOCUMENTS[fieldKey] ?? AMC_REQUIRED_DOCUMENTS.additionalDocument).title,
        value: documentsForm[fieldKey].fileName ?? '-',
    }));
});
const vehicleDetails = [
    'vehicleMake',
    'mentionedVehicleMake',
    'vehicleModel',
    'mentionedVehicleModel',
    'registrationNumber',
    'vehicleYear',
    'grossVehicleMass',
    'tare',
    'vehicleValue',
    'dateOfPurchase',
    'kiloMeterCompleted',
    'mileage',
    'vehicleIdNumber',
    'chassisNumber',
    'engineNumber',
    'exteriorColor',
    'interiorColor',
    'creditAgreement',
    'nameOfFinance',
    'addressOfFinance',
    'nameOfVehicleRegistration',
];
const incidentDetails = [
    'dateOfIncident',
    'reasonForDelay',
    'timeOfIncident',
    'addressOrLocation',
    'windScreenType',
    'causeOfBreakage',
    'personResponsible',
];
const driverDetails = ['driverName', 'driverLicense', 'driverLicenseNumber', 'driverLicenseCode'];
const thirdPartyDetails = ['thirdParty', 'thirdPartyName', 'thirdPartyNumber', 'thirdPartyAddress', 'thirdPartyEmail'];
const personToBeInformed = ['personToBeKeptInformed', 'personsFullName', 'personsContact', 'personsEmail'];
const caseDetails = [
    'dateOfIncident',
    'reasonForDelay',
    'timeOfIncident',
    'placeWhereTheftOccurred',
    'policeStationReportedTo',
    'sapsCaseNumber',
    'dateReported',
    'reportedBy',
    'circumstancesOfTheft',
    'vehicleLocked',
    'reasonOfLock',
    'detailsStolenAccessories',
    'associateSecured',
];
const vehicleRecoveryDeviceDetails = ['antiTheft', 'make', 'fittedBy', 'dateFitted'];
const windowMarkingDetails = ['windowNumber', 'appliedByWhom'];
const otherSpecificationDetails = ['detailsOfDents', 'detailsOfOtherFeatures'];
const otherDetailsKeys = ['description', 'windScreenSize', 'brokenGlass', 'crackOrShattered'];

export const getOtherDetailsSummary = createSelector(getOtherDetailsForm, (otherDetailsForm) => {
    return otherDetailsKeys.flatMap((fieldKey) =>
        otherDetailsForm[fieldKey].value
            ? {
                  label: OTHER_DETAIL_LABELS[fieldKey],
                  value: otherDetailsForm[fieldKey].value ?? '-',
              }
            : []
    );
});

export const getRecoveryDeviceSummary = createSelector(getOtherDetailsForm, (otherDetailsForm) => {
    return vehicleRecoveryDeviceDetails.flatMap((fieldKey) =>
        otherDetailsForm[fieldKey].value
            ? {
                  label: OTHER_DETAIL_LABELS[fieldKey],
                  value: otherDetailsForm[fieldKey].value ?? '-',
              }
            : []
    );
});
export const getWindowMarkingDetailsSummary = createSelector(getOtherDetailsForm, (otherDetailsForm) => {
    return windowMarkingDetails.flatMap((fieldKey) =>
        otherDetailsForm[fieldKey].value
            ? {
                  label: OTHER_DETAIL_LABELS[fieldKey],
                  value: otherDetailsForm[fieldKey].value ?? '-',
              }
            : []
    );
});
export const getOtherSpecsDetailsSummary = createSelector(getOtherDetailsForm, (otherDetailsForm) => {
    return otherSpecificationDetails.flatMap((fieldKey) =>
        otherDetailsForm[fieldKey].value
            ? {
                  label: OTHER_DETAIL_LABELS[fieldKey],
                  value: otherDetailsForm[fieldKey].value ?? '-',
              }
            : []
    );
});

export const getCaseDetailsSummary = createSelector(getOtherDetailsForm, (otherDetailsForm) => {
    return caseDetails.flatMap((fieldKey) =>
        otherDetailsForm[fieldKey].value
            ? {
                  label: OTHER_DETAIL_LABELS[fieldKey],
                  value: otherDetailsForm[fieldKey].value ?? '-',
              }
            : []
    );
});
export const getPoliceDetailsSummary = createSelector(getOtherDetailsForm, (otherDetailsForm) => {
    return Object.keys(POLICE_DETAILS_LABELS).flatMap((fieldKey) =>
        otherDetailsForm[fieldKey].value
            ? {
                  label: POLICE_DETAILS_LABELS[fieldKey],
                  value: otherDetailsForm[fieldKey].value ?? '-',
              }
            : []
    );
});
export const getOtherDriverDetailsSummary = createSelector(getOtherDetailsForm, (otherDetailsForm) => {
    return Object.keys(DRIVER_DETAILS).flatMap((fieldKey) =>
        otherDetailsForm[fieldKey].value
            ? {
                  label: DRIVER_DETAILS[fieldKey],
                  value: otherDetailsForm[fieldKey].value ?? '-',
              }
            : []
    );
});
export const getOtherThirdPartyDetailsSummary = createSelector(getOtherDetailsForm, (otherDetailsForm) => {
    return Object.keys(OTHER_THIRD_PARTY).flatMap((fieldKey) =>
        otherDetailsForm[fieldKey].value
            ? {
                  label: OTHER_THIRD_PARTY[fieldKey],
                  value: otherDetailsForm[fieldKey].value ?? '-',
              }
            : []
    );
});
export const getDamagedPropertyDetailsSummary = createSelector(getOtherDetailsForm, (otherDetailsForm) => {
    return Object.keys(DAMAGE_PROPERTY).flatMap((fieldKey) =>
        otherDetailsForm[fieldKey].value
            ? {
                  label: DAMAGE_PROPERTY[fieldKey],
                  value: otherDetailsForm[fieldKey].value ?? '-',
              }
            : []
    );
});
export const getPersonalInjuriesDetailsSummary = createSelector(getOtherDetailsForm, (otherDetailsForm) => {
    return Object.keys(PERSONAL_INJURIES).flatMap((fieldKey) =>
        otherDetailsForm[fieldKey].value
            ? {
                  label: PERSONAL_INJURIES[fieldKey],
                  value: otherDetailsForm[fieldKey].value ?? '-',
              }
            : []
    );
});
export const getIncidentDetailsSummary = createSelector(getIncidentDetailsForm, (incidentDetailsForm) => {
    return incidentDetails.flatMap((fieldKey) =>
        incidentDetailsForm[fieldKey].value
            ? {
                  label: INCIDENT_DETAIL_LABELS[fieldKey],
                  value: incidentDetailsForm[fieldKey].value ?? '-',
              }
            : []
    );
});
export const getPersonToBeInformedSummary = createSelector(getIncidentDetailsForm, (incidentDetailsForm) => {
    return personToBeInformed.flatMap((fieldKey) =>
        incidentDetailsForm[fieldKey].value
            ? {
                  label: INCIDENT_DETAIL_LABELS[fieldKey],
                  value: incidentDetailsForm[fieldKey].value ?? '-',
              }
            : []
    );
});
export const getVehicleDetailsSummary = createSelector(getIncidentDetailsForm, (incidentDetailsForm) => {
    return vehicleDetails.flatMap((fieldKey) =>
        incidentDetailsForm[fieldKey].value
            ? {
                  label: INCIDENT_DETAIL_LABELS[fieldKey],
                  value: incidentDetailsForm[fieldKey].value ?? '-',
              }
            : []
    );
});
export const getDriverDetailsSummary = createSelector(getIncidentDetailsForm, (incidentDetailsForm) => {
    return driverDetails.flatMap((fieldKey) =>
        incidentDetailsForm[fieldKey].value
            ? {
                  label: INCIDENT_DETAIL_LABELS[fieldKey],
                  value: incidentDetailsForm[fieldKey].value ?? '-',
              }
            : []
    );
});
export const getThirdPartyDetailsSummary = createSelector(getIncidentDetailsForm, (incidentDetailsForm) => {
    return thirdPartyDetails.flatMap((fieldKey) =>
        incidentDetailsForm[fieldKey].value
            ? {
                  label: INCIDENT_DETAIL_LABELS[fieldKey],
                  value: incidentDetailsForm[fieldKey].value ?? '-',
              }
            : []
    );
});
export const getAccidentDetailsSummary = createSelector(getIncidentDetailsForm, (incidentDetailsForm) => {
    return Object.keys(ACCIDENT_LABELS).flatMap((fieldKey) =>
        incidentDetailsForm[fieldKey].value
            ? {
                  label: ACCIDENT_LABELS[fieldKey],
                  value: incidentDetailsForm[fieldKey].value ?? '-',
              }
            : []
    );
});
export const getWitnessDetailsSummary = createSelector(getIncidentDetailsForm, (incidentDetailsForm) => {
    return Object.keys(incidentDetailsForm)
        .filter((key) => key.startsWith('witness'))
        .flatMap((fieldKey) => {
            const witnessCount = fieldKey.split('_')[1] ?? '';
            const witnessLabelKey = fieldKey.split('_')[0] ?? '';
            return incidentDetailsForm[fieldKey].value
                ? {
                      label: `${WITNESS_DETAILS[witnessLabelKey]} ${witnessCount} (Optional)`,
                      value: incidentDetailsForm[fieldKey].value ?? '-',
                  }
                : [];
        });
});
export const getOtherWitnessDetailsSummary = createSelector(getOtherDetailsForm, (otherDetailsForm) => {
    return Object.keys(otherDetailsForm)
        .filter((key) => key.startsWith('witness'))
        .flatMap((fieldKey) => {
            const witnessCount = fieldKey.split('_')[1] ?? '';
            const witnessLabelKey = fieldKey.split('_')[0] ?? '';
            return otherDetailsForm[fieldKey].value
                ? {
                      label: `${WITNESS_DETAILS[witnessLabelKey]} ${witnessCount} (Optional)`,
                      value: otherDetailsForm[fieldKey].value ?? '-',
                  }
                : [];
        });
});
const passengerKeys = ['employee', 'purpose'];
export const getPassengerDetailsSummary = createSelector(getIncidentDetailsForm, (incidentDetailsForm) => {
    const filteredPassengers = Object.keys(incidentDetailsForm).filter((key) => key.startsWith('passenger'));
    return ['anyPassenger', ...passengerKeys, ...filteredPassengers].flatMap((fieldKey) => {
        const passengerCount = fieldKey.split('_')[1] ?? '';
        const passengerLabelKey = fieldKey.split('_')[0] ?? '';
        return incidentDetailsForm[fieldKey].value
            ? {
                  label: `${DETAILS_OF_PASSENGER[passengerLabelKey]} ${passengerCount} (Optional)`,
                  value: incidentDetailsForm[fieldKey].value ?? '-',
              }
            : [];
    });
});

export const getClaimDetailsSummary = createSelector(
    getIncidentDetailsSummary,
    getVehicleDetailsSummary,
    getDriverDetailsSummary,
    getThirdPartyDetailsSummary,
    getWitnessDetailsSummary,
    getPersonToBeInformedSummary,
    getBasicDetailsSummary,
    getOtherDetailsSummary,
    getDocumentsSummary,
    getBasicDetailsForm,
    getCaseDetailsSummary,
    getRecoveryDeviceSummary,
    getWindowMarkingDetailsSummary,
    getOtherSpecsDetailsSummary,
    getAccidentDetailsSummary,
    getPassengerDetailsSummary,
    getPoliceDetailsSummary,
    getOtherDriverDetailsSummary,
    getOtherThirdPartyDetailsSummary,
    getDamagedPropertyDetailsSummary,
    getPersonalInjuriesDetailsSummary,
    getOtherWitnessDetailsSummary,

    (
        incidentDetailsSummary,
        vehicleDetailsSummary,
        driverDetailsSummary,
        thirdPartyDetailsSummary,
        witnessSummary,
        personToBeInformedSummary,
        basicDetailsSummary,
        otherDetailsSummary,
        documentsSummary,
        { categoryType },
        caseDetailsSummary,
        recoveryDeviceSummary,
        windowMarkingDetailsSummary,
        otherSpecDetailsSummary,
        accidentDetailsSummary,
        passengerDetailsSummary,
        policeDetailsSummary,
        otherDriverDetailsSummary,
        otherThirdPartyDetailsSummary,
        damagedPropertyDetailsSummary,
        personalInjuriesDetailsSummary,
        otherWitnessDetailsSummary
    ) => {
        const claimDetailsSummary = [
            {
                key: 'claimDetails',
                title: 'Claim Details',
                data: [
                    { value: 'Allsure Motor Claim', label: 'Claim name' },
                    { value: categoryType.displayValue, label: 'Claim type/category' },
                ],
            },
            {
                key: 'basicDetails',
                title: 'Basic Details',
                data: basicDetailsSummary,
                editable: true,
            },
            {
                key: 'vehicleDetails',
                title: 'Vehicle Details',
                data: vehicleDetailsSummary,
                editable: true,
            },
            {
                key: 'incidentDetails',
                title: 'Incident Details',
                data: incidentDetailsSummary,
                editable: true,
            },
            {
                key: 'driverDetails',
                title: 'Driver Details',
                data: driverDetailsSummary,
                editable: true,
            },
            {
                key: 'accidenteDetails',
                title: 'Accident Details',
                data: accidentDetailsSummary,
                editable: true,
            },
            {
                key: 'thirdPartyDetails',
                title: 'Third Party Details (Incident Details)',
                data: thirdPartyDetailsSummary,
                editable: true,
            },
            {
                key: 'personToBeInformed',
                title: 'Alternate Person Contact Details',
                data: personToBeInformedSummary,
                editable: true,
            },
            {
                key: 'witnessSummary',
                title: 'Witness Details',
                data: witnessSummary,
                editable: true,
            },
            {
                key: 'passengerDetails',
                title: 'Passenger’s Details',
                data: passengerDetailsSummary,
                editable: true,
            },
            // WindScreen IncidentDetails
            {
                key: 'otherDetails',
                title: 'Other Details',
                data: otherDetailsSummary,
                editable: true,
            },
            {
                key: 'caseDetails',
                title: 'Case Details',
                data: caseDetailsSummary,
                editable: true,
            },
            {
                key: 'vehicleRecoveryDeviceDetails',
                title: 'Anti-Theft/Vehicle Recovery Device Details',
                data: recoveryDeviceSummary,
                editable: true,
            },
            {
                key: 'windowMarkingDetails',
                title: 'Window Markings Details',
                data: windowMarkingDetailsSummary,
                editable: true,
            },
            {
                key: 'otherSpecificationDetails',
                title: 'Other Specification Details',
                data: otherSpecDetailsSummary,
                editable: true,
            },
            //Theft
            {
                key: 'policeDetails',
                title: 'Police Report Details',
                data: policeDetailsSummary,
                editable: true,
            },
            {
                key: 'otherDriverDetails',
                title: 'Driver Details',
                data: otherDriverDetailsSummary,
                editable: true,
            },
            {
                key: 'otherThirdPartyDetails',
                title: 'Third Party Details (Other Details)',
                data: otherThirdPartyDetailsSummary,
                editable: true,
            },
            {
                key: 'damagedOtherThanVehicle',
                title: 'Damaged Property Other Than Vehicle',
                data: damagedPropertyDetailsSummary,
                editable: true,
            },
            {
                key: 'personalInjuriesDetails',
                title: "Personal Injuries Other Than (Insured's Vehicle)",
                data: personalInjuriesDetailsSummary,
                editable: true,
            },
            {
                key: 'otherWitnessDetails',
                title: 'Witness Details',
                data: otherWitnessDetailsSummary,
                editable: true,
            },
            {
                key: 'documentDetails',
                title: 'Document Details',
                data: documentsSummary,
                editable: true,
            },
        ];
        return claimDetailsSummary.filter((element) => element.data.length > 0);
    }
);
